<template>
  <div class="about-view">

    <router-view />
  </div>
</template>

<script>
import updateBreadcrumb from '@mixins/updateBreadcrumb'
export default {
  name: 'AboutView',
  components: {},
  mixins: [ updateBreadcrumb ],
  beforeRouteEnter (to, from, next) {
    next(to.matched.length !== 1)
  },
  beforeRouteUpdate (to, from, next) {
    next(to.matched.length !== 1)
  }
}
</script>
